var map = {
	"./rocket/level/Bronze.png": 73331,
	"./rocket/level/Diamond.png": 97429,
	"./rocket/level/Emerald.png": 52577,
	"./rocket/level/Gold.png": 46650,
	"./rocket/level/Platinum.png": 97086,
	"./rocket/level/Ruby.png": 8756,
	"./rocket/level/Silver.png": 99391,
	"./rocket/level/Wish.png": 21912,
	"./tapcoin/level/Bronze.png": 81649,
	"./tapcoin/level/Diamond.png": 17308,
	"./tapcoin/level/Emerald.png": 39975,
	"./tapcoin/level/Gold.png": 88027,
	"./tapcoin/level/Platinum.png": 96604,
	"./tapcoin/level/Ruby.png": 29676,
	"./tapcoin/level/Silver.png": 97004,
	"./tapcoin/level/Wish.png": 85792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25847;